import { BoxProps } from '../Box';

export interface SkeletonRectangleProps {
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook?: string;
  /**
   * Specifies a CSS class name to be appended to the component’s root element.
   * @internal
   */
  className?: string;
  /** Sets the height of the box (pixels) */
  height?: BoxProps['height'];
  /** Sets the width of the box (pixels) */
  width?: BoxProps['width'];
  /**
   * Sets margin on all sides.
   * Accepts a numeric value (multiplied by spacing unit), predefined spacing value (tiny, small, etc.)
   * a spacing token (SP1, SP2, etc.) or a string of space-separated values ("3px 3px")
   */
  margin?: BoxProps['margin'];
  /**
   * Sets margin on the top.
   * Accepts a numeric value (multiplied by spacing unit), predefined spacing value (tiny, small, etc.)
   * a spacing token (SP1, SP2, etc.) or a string of space-separated values ("3px 3px")
   */
  marginTop?: BoxProps['marginTop'];
  /**
   * Sets margin on the right.
   * Accepts a numeric value (multiplied by spacing unit), predefined spacing value (tiny, small, etc.)
   * a spacing token (SP1, SP2, etc.) or a string of space-separated values ("3px 3px")
   */
  marginRight?: BoxProps['marginRight'];
  /**
   * Sets margin on the bottom.
   * Accepts a numeric value (multiplied by spacing unit), predefined spacing value (tiny, small, etc.)
   * a spacing token (SP1, SP2, etc.) or a string of space-separated values ("3px 3px")
   */
  marginBottom?: BoxProps['marginBottom'];
  /**
   * Sets margin on the left.
   * Accepts a numeric value (multiplied by spacing unit), predefined spacing value (tiny, small, etc.)
   * a spacing token (SP1, SP2, etc.) or a string of space-separated values ("3px 3px")
   */
  marginLeft?: BoxProps['marginLeft'];
}
